// Leaf module to avoid circular import between microservices.ts and microservices-register.generated.ts
export const USD_TO_EUR = 0.92;
export const usdToEur = (usd: number) => Math.max(1, Math.round(usd * USD_TO_EUR));